<template>
  <section class="section container-fluid">
    <div class="body-wrapper">
      <div class="logo">
        <img src="@/assets/TAJimages/TAJBank+strapline_RGB_large.png" width="25%" class="img-fluid" alt="logo">
      </div>
      <div class="header-title">
        <h1>Transaction Receipt</h1>
        <p>From TAJWeb</p>
      </div>
      <div class="child-receipt-wrapper mt-4">
        <div class="receipt-content px-4 d-flex">
          <h3>Transaction Amount:</h3>
          <h4 class="receipt-text">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(details.amount)}}</h4>
        </div>
        <div class="receipt-content px-4 d-flex">
          <h3>Transaction Type:</h3>
          <h4 class="receipt-text">{{ details.transactionType === 1 ? 'Own Account Transfer' : details.transactionType === 2 ? 'TAJBank Transfer' : details.transactionType === 3 ? 'Interbank Transfer' : details.transactionType === 4 ? 'Bills Payment' : details.transactionType === 5 ? 'Airtime Purchase' : details.transactionType === 6 ? 'Bulk Transfer' : details.transactionType === 11 ? 'Standing Instruction' : details.transactionType === 12 ? 'Fund Account' : details.transactionType == 13 ? 'Token Request' : details.transactionType == 14 ? 'Cheque Request' : details.transactionType == 17 ? 'Flight Payment' : details.transactionType == 18 ? 'Hotel Payment' : details.transactionType == 16 ? 'Lifestyle Payment' : 'Limit Upgrade' }}</h4>
        </div>
        <div class="receipt-content px-4 d-flex">
          <h3>Transaction Date:</h3>
          <h4 class="receipt-text">{{details.createdDate | moment}}</h4>
        </div>
        <div class="receipt-content px-4 d-flex">
          <h3>Sender:</h3>
          <div class="receipt-text details-wrapper-1">
            <h4 class="receipt-text">{{details.debitAccountName}}</h4>
            <h4 class="receipt-text mt-2">{{maskedDebitAccountNumber}}</h4>
          </div>
        </div>
        <div v-if="details.destinationBankName || details.creditAccountNumber || details.creditAccountName" class="receipt-content px-4 d-flex">
          <h3>Beneficiary:</h3>
          <div class="receipt-text details-wrapper">
            <h4 class="receipt-text">{{details.creditAccountName}}</h4>
            <h4 class="receipt-text mt-2">{{details.creditAccountNumber}}</h4>
            <h4 class="receipt-text mt-2">{{details.destinationBankName}}</h4>
          </div>
        </div>
        <div class="receipt-content px-4 d-flex">
          <h3>Narration:</h3>
          <h4 class="receipt-text">{{details.narration}}</h4>
        </div>
        <div class="receipt-content px-4 d-flex">
          <h3>Transaction Reference:</h3>
          <h4 class="receipt-text">{{details.transactionReference}}</h4>
        </div>
        <div class="receipt-content px-4 d-flex">
          <h3>Transaction Status:</h3>
          <h4 class="receipt-text">{{details.status === 0 ? 'SUCCESSFUL' : 'FAILED'}}</h4>
        </div>
        <div v-if="details.sessionId" class="receipt-content px-4 d-flex">
          <h3>Session ID:</h3>
          <h4 class="receipt-text">{{details.sessionId}}</h4>
        </div>
        <div v-if="details.biller" class="receipt-content px-4 d-flex">
          <h3>Biller:</h3>
          <h4 class="receipt-text">{{details.biller}}</h4>
        </div>
        <div v-if="details.paymentToken" class="receipt-content px-4 d-flex">
          <h3>Token:</h3>
          <h4 class="receipt-text">{{details.paymentToken}}</h4>
        </div>
        <div v-if="details.requestID" class="receipt-content px-4 d-flex">
          <h3>PNR Number:</h3>
          <h4 class="receipt-text">{{details.requestID}}</h4>
        </div>
      </div>
      <!-- <div class="line bottom-line"></div> -->
      <div class="footer-section text-center">
        <p class="footer-header">DISCLAIMER</p>
        <p class="footer-subtext">Your transaction has been successful and the recipient’s account will be credited. However, this does not serve as confirmation of credit into the recipient’s account. Due to the nature of the Internet, transactions may be subject to interruption, delay and incorrect data transmission. TAJBank is not liable for malfunctions in communications facilities. All transactions are subject to verification and our security checks.
        </p>
      </div>
    </div>
</section>
</template>

<script>
  import moment from 'moment';
  export default {
    filters: {
      moment: function (date) {
        return moment(date).format('Do MMM YYYY, hh:mm:A');
      }
    },
    props: {
      details: {
        type: Object,
        required: true,
      },
    },
    computed: {
      maskedDebitAccountNumber: function() {
        let accountNumber = this.details.debitAccountNumber;
        let maskedAccount = accountNumber.substring(0, 3) + '****' + accountNumber.substring(accountNumber.length - 3, accountNumber.length);
        return maskedAccount;
      },
    }
  };
</script>

<style scoped>
* {
  font-family: 'Open Sans', sans-serif !important;
}
.section{
  padding: 0;
  margin: 0;
  /* padding: 0 45px; */
  background:url(../../../assets/TAJimages/receipt_bg.png);
  background-repeat: no-repeat;
  background-size: cover !important;
  height: 100%;
}
.body-wrapper {
  padding: 0px 40px
}
.receipt-content {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 20px 50px #00000019;
  border-radius: 17px;
  opacity: 1;
  padding: 17px;
  margin-top: 18px;
}
.receipt-content h3 {
  text-align: left;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 0px;
  color: #D52B1E;
  opacity: 1;
  margin-bottom: 0;
  width: 300px;
}
.receipt-text {
  /* margin-left: 200px; */
  width: 500px;
  margin: 0 auto;
  margin-bottom: 0;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #2E364B;
  opacity: 1;
}
.details-wrapper {
  margin-left: 150px;
}
.details-wrapper-1 {
  margin-left: 180px;
}
.header-title {
  text-align: center;
  /* padding-top: 22%; */
}
.header-title h1 {
  font-size: 23px;
  color: #2E364B;
  font-weight: 800;
  letter-spacing: 0;
}
.header-title p {
  font-size: 15px;
  color: #7F7F7F;
  font-weight: bold;
  letter-spacing: 0;
}
.footer-section {
  margin-top: 50px;
  /* padding-bottom: 50px; */
}
.footer-section .footer-header {
  font-size: 17px;
  letter-spacing: 0px;
  color: #1E1147;
  opacity: 1;
  font-weight: 500;
}
.footer-section .footer-subtext {
  text-align: center;
  font-size: 13px;
  letter-spacing: 0px;
  color: #2E364B;
  opacity: 1;
  font-weight: 400;
  margin-bottom: 0;
}
</style>